import { createContext, FC, useContext, useState } from 'react';

export const NotificationsDrawerContext = createContext<{
  visibility: boolean;
  setVisibility: (any) => void;
} | null>(null);

export const useNotificationsDrawerContext = () => {
  const context = useContext(NotificationsDrawerContext);

  if (!context) {
    throw new Error('No data available');
  }

  return context;
};

export const NotificationsDrawerContextProvider: FC<
  React.PropsWithChildren<unknown>
> = ({ children }) => {
  const [visibility, setVisibility] = useState(false);

  return (
    <NotificationsDrawerContext.Provider value={{ visibility, setVisibility }}>
      {children}
    </NotificationsDrawerContext.Provider>
  );
};
